/*	required for setting up initially shown map
 *	geodata (lat/lng) can be determined using a tool like
 *	http://gmaps-samples-v3.googlecode.com/svn/trunk/geocoder/v3-geocoder-tool.html
 */

'use strict';

var _slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i && _arr.length === i)
                    break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally {
            try {
                if (!_n && _i["return"])
                    _i["return"]();
            } finally {
                if (_d)
                    throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    }
    ;
}();
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
}
: function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
;

var initialMapCenterLatitude = 51.165691;
var initialMapCenterLongitude = 10.451526;
//var initialMapCenterLatitude = window.initialMapCenterLatitude;
//var initialMapCenterLongitude = window.initialMapCenterLongitude;
var initialMapZoom = 5;

var MAPFILES_URL = "//maps.gstatic.com/mapfiles/";

var directionsDisplay;
var locationIconShadow;
var directionsService = new google.maps.DirectionsService();
var map = null;
var geocoder = null;
var shadow = null;
var locationIcon = null;
var locationMarker = null;
var queryLocation = null;

var totalItems = 0;
var markers = [];
var selected = null;
var infowindow = null;
var layer;
// maximum number of items shown in result
var maximumItemsPerPage = 4;
// number of next/previous page links
var pageControls = 5;
// distance in meters
var MAX_DISTANCE = 100000;
// query offset
var offset = 0;
var dataTable = void 0;
var locationResult = null;
var totalPages = 0;

var GEOJSON_LAYER_ID = 'geojson-layer';
var ICON_LAYER_ID = 'icon-layer';
var driveUrl = 'https://www.googleapis.com/drive/v3/files/1vnqA-Gc7zpkXR2QShiRXB1uBt_gQP5k-bewOcVYWt2w/export?mimeType=text%2Fcsv&key=AIzaSyC6TkvahlfVzHmEXV1HTfrorF1VwwNkmPA';
var allData;
var filteredData;
var overlay;


var mapIconLocation = 'https://cdn.shopify.com/s/files/1/0342/5982/8869/files/maps-icon-2.png?v=1666878563';
var mapIconDot = 'https://cdn.shopify.com/s/files/1/0342/5982/8869/files/maps-dot-icon.png?v=1666879355';
var styleAtributes = [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}];

var currentUserLocation;
function init(locale) {
    fillCountrySelector(locale);
    // clearOptions();

    directionsDisplay = new google.maps.DirectionsRenderer({
        markerOptions:{
            icon: mapIconLocation
        }
    });

    var mapOptions = {
        'zoom': initialMapZoom,
        'center': new google.maps.LatLng(initialMapCenterLatitude,initialMapCenterLongitude),
        'mapTypeId': google.maps.MapTypeId.ROADMAP,
        'scaleControl': true,
        'mapTypeControl': false,
        'streetViewControl': false,
        'styles': styleAtributes
    };

    map = new google.maps.Map(document.getElementById("maps-container"),mapOptions);

    directionsDisplay.setPanel(document.getElementById("directions-panel"));

    geocoder = new google.maps.Geocoder();

    infowindow = new google.maps.InfoWindow({
        'size': new google.maps.Size(292,120)
    });

    shadow = new google.maps.MarkerImage(MAPFILES_URL + "shadow50.png",new google.maps.Size(37,34),new google.maps.Point(0,0),new google.maps.Point(10,34));

    locationIcon = new google.maps.MarkerImage(MAPFILES_URL + 'arrow.png',new google.maps.Size(39,34),new google.maps.Point(0,0),new google.maps.Point(10,34));

    locationIconShadow = new google.maps.MarkerImage(MAPFILES_URL + 'arrowshadow.png',new google.maps.Size(39,34),new google.maps.Point(0,0),new google.maps.Point(10,34));
    document.querySelector('#navigation-info').classList.add('js-hidden');

    getCurrentLocation();
}

function fillCountrySelector(locale) {
    var localeColumn;
    if (locale === 'en')
        localeColumn = 'I';
    else if (locale === 'de')
        localeColumn = 'J';
    else if (locale === 'fr')
        localeColumn = 'K';
    else if (locale === 'it')
        localeColumn = 'L';

    var query = "select H, " + localeColumn + ", max(D) group by H, " + localeColumn + " order by " + localeColumn;
    retrieveData(query, buildSelectBox);
}

function buildSelectBox(response) {
    if (!response) {
        alert(messages['noresponse']);
    } else {
        if (response.isError()) {
            alert(response.getMessage() + '. ' + response.getDetailedMessage());
        } else {

            var selectBox = $('#countrySelectBox');

            dataTable = response.getDataTable();
            for (var z = 0; z < dataTable.getNumberOfRows(); z++) {
                var rowValues = getDatatableRowValues(dataTable, z);
                selectBox.append('<option value="' + rowValues[0] + '">' + rowValues[1] + '</option>');
            }
        }
        // $("#countrySelectBox").data("selectBox-selectBoxIt").refresh();
    }
}

function calcRoute() {
    if (selected != null) {
        var marker = markers[selected];
        var end = marker.getPosition();
        var start = document.getElementById("route-start").value;
        var request = {
            origin: start,
            destination: end,
            travelMode: google.maps.DirectionsTravelMode.DRIVING
        };

        directionsDisplay.setMap(map);

        directionsService.route(request, function(response, status) {
            if (status == google.maps.DirectionsStatus.OK) {
                resetMap();
                $("#directions").show();
                directionsDisplay.setDirections(response);
            } else {
                var statusMessage = (directionsMessages[status] != undefined) ? directionsMessages[status] : status;
                alert(statusMessage);
            }
        });
    }
}

function submitQuery() {
    var query = document.getElementById("query").value;
    // var countryIsocode = document.getElementById("countrySelectBox").value;
    geocode({
        'address': query,
        'region': 'de'
    });
}

function showPage(pageNumber) {
    infowindow.close();
    resetMarkers();
    offset = (pageNumber > 1) ? ((pageNumber - 1) * maximumItemsPerPage) : 0;
    showResults();
}

function geocode(request) {

    // clear route
    directionsDisplay.setMap(null);
    resetMap();
    geocoder.geocode(request, processGeoderResult);
}

function processGeoderResult(results, status) {

    if (!results) {
        alert(+messages['noresponse']);
    } else {
        if (status == google.maps.GeocoderStatus.OK) {

            // store query location
            queryLocation = results[0].geometry.location;

            if (results[0].types[0] == 'street_address') {
                addLocationMarker(results[0]);
            }

            locationResult = results[0];

            if (!allData)
                loadDeckglGoogleMapsOverlay();
            else
                loadResults();
        } else {
            var statusMessage = (geocoderMessages[status] != undefined) ? geocoderMessages[status] : status;
            alert(statusMessage);
            resetMap();
            map.setCenter(new google.maps.LatLng(initialMapCenterLatitude,initialMapCenterLongitude));
            map.setZoom(initialMapZoom);
        }
    }
}

function loadDeckglGoogleMapsOverlay() {
    $.ajax({
        url: driveUrl,
        type: 'GET',
        success: function(csv) {
            var parsedData = Papa.parse(csv);
            var data = parseGeoData(parsedData.data);
            allData = data;
            loadResults();
            if (deck != undefined) {
                overlay = new deck.GoogleMapsOverlay({
                    layers: [new deck.GeoJsonLayer({
                        id: GEOJSON_LAYER_ID,
                        data: createGeojsonFromData(data),
                        pickable: true,
                        stroked: true,
                        filled: true,
                        lineWidthUnits: 'pixels',
                        lineWidthMinPixels: 1,
                        pointRadiusMinPixels: 3,
                        getRadius: 0,
                        wrapLongitude: true,
                        getFillColor: function getFillColor() {
                            return [160, 160, 180, 200];
                        },
                        getLineColor: function getLineColor() {
                            return [239, 83, 80, 214];
                        },
                        getLineWidth: function getLineWidth() {
                            return 1;
                        },
                        autoHighlight: true
                    }), new deck.IconLayer({
                        id: ICON_LAYER_ID,
                        data: createIconsFromData(data),
                        getIcon: function getIcon() {
                            return {
                                url: mapIconDot, //'http://coeur.scene7.com/is/image/Coeur/red%2Ddot',
                                width: 9,
                                height: 9,
                                anchorX: 4.5,
                                anchorY: 4.5
                            };
                        },
                        getSize: function getSize() {
                            return 12;
                        },
                        pickable: true,
                        wrapLongitude: true
                    })]
                });
                overlay.setMap(map);
                initInfowindow(map, overlay);
            }
        }
    });
}

function loadResults() {
    filteredData = [];
    allData.forEach(function(item) {
        var distance = google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng({
            lat: queryLocation.lat(),
            lng: queryLocation.lng()
        }), new google.maps.LatLng({
            lat: Number(item[5]),
            lng: Number(item[6])
        }));

        if (MAX_DISTANCE > distance) {
            filteredData.push({
                distance: distance,
                //data: [latitude, longitude, name, street, postcide, city, www]
                data: [item[5], item[6], item[1], item[2], item[3], item[4], item[15]]
            });
        }
    });
    filteredData = filteredData.sort(function(a, b) {
        return parseFloat(a.distance) - parseFloat(b.distance);
    });

    totalItems = filteredData.length;
    totalPages = parseInt(totalItems / maximumItemsPerPage) + (totalItems % maximumItemsPerPage ? 1 : 0);
    showResults();
}

function plotMatchesOnMap(dataTable) {
    resetMarkers();
    markers = new Array(dataTable.getNumberOfRows());
    var resultsListHtml = "";

    var openInfoWindow = function openInfoWindow(resultNum, rowValues, marker) {
        return function() {
            var selectedElement = document.getElementById('p' + selected);
            if (selectedElement) {
                removeClass(selectedElement, "selected");
            }

            infowindow.setContent(getAddressComponentsHtml(rowValues, true));
            infowindow.open(map, marker);

            addClass(document.getElementById('p' + resultNum), "selected");
            document.getElementById('matches').scrollTop = document.getElementById('p' + resultNum).offsetTop - document.getElementById('matches').offsetTop;
            selected = resultNum;
        }
        ;
    };

    for (var i = 0; i < (maximumItemsPerPage < dataTable.getNumberOfRows() ? maximumItemsPerPage : dataTable.getNumberOfRows()); i++) {

        var rowValues = getDatatableRowValues(dataTable, i);

        var lat = rowValues[0];
        var lng = rowValues[1];

        // var icon = new google.maps.MarkerImage(getMarkerImageUrl(i),new google.maps.Size(20,34),new google.maps.Point(0,0),new google.maps.Point(10,34));
        let markerContent = `
            <div style="text-align:center">
                <p>`+rowValues[2]+`</p>
                <button style="padding:0 5px; height:25px;" onclick="showRouteToStore(`+lat+`,`+lng+`)"> Show Route </button>
            </div>
        `;

        let optionsMaker = {
            'position': new google.maps.LatLng(lat,lng),
            'map': map,
            'content': markerContent,
            'icon': mapIconLocation,
            'shadow': shadow
        }
        // markers[i] = new google.maps.Marker({
        //     'position': new google.maps.LatLng(lat,lng),
        //     'map': map,
        //     'icon': icon,
        //     'shadow': shadow
        // });
        markers[i] = new google.maps.Marker(optionsMaker);
        google.maps.event.addListener(markers[i], 'click', openInfoWindow(i, rowValues, markers[i]));

        resultsListHtml += getResultsListItem(i, getResultDescription(rowValues));
    }

    document.getElementById("matches").innerHTML = resultsListHtml;

    zoomToMarkers();
}

function showResults() {
    $(".defaultAddresses").hide();
    if (totalItems > 0) {

        var dataTableResult = new google.visualization.DataTable();
        dataTableResult.addColumn('string', 'latitude', 'col6');
        dataTableResult.addColumn('string', 'longitude', 'col7');
        dataTableResult.addColumn('string', 'name', 'col2');
        dataTableResult.addColumn('string', 'street', 'col3');
        dataTableResult.addColumn('string', 'postcode', 'col4');
        dataTableResult.addColumn('string', 'city', 'col5');
        dataTableResult.addColumn('string', 'www', 'col15');
        var limit = offset + maximumItemsPerPage < totalItems ? maximumItemsPerPage : totalItems - offset;
        for (var i = 0; i < limit; i++) {
            dataTableResult.addRow(filteredData[i + offset].data);
        }

        plotMatchesOnMap(dataTableResult);

        var html = "<div class='pagination'>";

        html += getPageControlItem(currentPageNumber() - 1, page_prev, "prev-page");

        var maxPageNumber = void 0
          , minPageNumber = void 0
          , threshold = void 0
          , leftBoundary = void 0
          , rightBoundary = void 0;
        threshold = (pageControls - 1) / 2;
        rightBoundary = Math.max(pageControls, currentPageNumber() + threshold);
        leftBoundary = Math.min(totalPages - (pageControls - 1), currentPageNumber() - threshold);
        maxPageNumber = Math.min(rightBoundary, totalPages);
        minPageNumber = Math.max(leftBoundary, 1);

        for (var _i = minPageNumber; _i <= maxPageNumber; _i++) {
            html += getPageControlItem(_i, _i, "curr-page");
        }

        html += getPageControlItem(Math.min(currentPageNumber() + 1, totalPages), page_next, "next-page");

        html += "</ul>";
        document.getElementById("navigation-info-start").innerHTML = (currentPageNumber() - 1) * maximumItemsPerPage + 1;
        document.getElementById("navigation-info-end").innerHTML = (currentPageNumber() - 1) * maximumItemsPerPage + maximumItemsPerPage < totalItems ? (currentPageNumber() - 1) * maximumItemsPerPage + maximumItemsPerPage : totalItems;
        document.getElementById("navigation-info-total").innerHTML = totalItems;
        document.getElementById("navigation").innerHTML = html;
        document.querySelector('#navigation-info').classList.remove('js-hidden');

        $("#matchlist").show();
    } else {
        resetMap();
        map.setCenter(new google.maps.LatLng(initialMapCenterLatitude,initialMapCenterLongitude));
        map.setZoom(initialMapZoom);
        var currentCountryISO = document.getElementById("countrySelectBox")?.value.toLowerCase();
        var defaultAddress = $('#address_' + currentCountryISO);
        document.querySelector('#navigation-info').classList.add('js-hidden');
        if (defaultAddress) {
            defaultAddress.show();
        } else {

            alert(messages['noresult']);
        }
    }
}

function print() {
    var marker = markers[selected];
    var start = directionsDisplay.getDirections().routes[0].legs[0].start_address;
    var end = directionsDisplay.getDirections().routes[0].legs[directionsDisplay.getDirections().routes[0].legs.length - 1].end_address;
    window.open("//maps.google.com/maps?saddr=" + encodeURIComponent(start) + "&daddr=" + encodeURIComponent(end) + "&ie=UTF8&pw=2&layer=c&z=" + map.getZoom(), 'myWindow', 'toolbar=no,location=no,directories=no,status=no, menubar=no,scrollbars=yes,resizable=yes,width=800,height=800');
}

function getPageControlItem(pageNumber, label, styleClass) {
    var html = "";
    var clickevent = "";
    if (pageNumber == currentPageNumber()) {
        styleClass = "current " + styleClass;
        html = "<span class='" + styleClass + "'>" + label + "</span>";
        return html;
    } else {
        clickevent = "onclick='showPage(" + pageNumber + ");return false;'";
    }

    html = "<span class='" + styleClass + "'><a href='#' " + clickevent + "  >" + label + "</a></span>";

    return html;
}

function currentPageNumber() {
    return offset / maximumItemsPerPage + 1;
}

function getResultsListItem(resultNum, resultDescription) {
    var html = '<li>';
    html += '<div class="dealer-address" id="p' + resultNum + '" onclick="selectMarker(' + resultNum + ')">';
    html += '<img class="maps-marker" src="' + getMarkerImageUrl(resultNum) + '"></img>';
    html += resultDescription;
    html += "</div>";
    html += "</li>";
    return html;
}

function getResultDescription(rowValues) {
    var html = "<address>";
    html += '<span class="content-sub-title" data-dealer-address-title="' + rowValues[2] + '">' + rowValues[2] + '</span>';
    html += "<p>" + rowValues[3] + "<br>" + rowValues[4] + "&nbsp;" + rowValues[5];
    html += "<br><a class='link-dealer' href='" + rowValues[6] + "' target='_blank'>" + rowValues[6] + "</a>";
    //url
    html += "</p>";
    html += "</address>";

    return html;
}

function getDatatableRowValues(dataTable, rowIndex) {
    var rowValues = [];
    if (dataTable.getNumberOfRows() >= rowIndex + 1) {
        for (var i = 0; i < dataTable.getNumberOfColumns(); i++) {

            rowValues[i] = dataTable.getValue(rowIndex, i);
        }
    }
    return rowValues;
}

function zoomToMarkers() {
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
        bounds.extend(markers[i].getPosition());
    }

    if (locationMarker != null) {
        bounds.extend(locationMarker.getPosition());
    }
    map.fitBounds(bounds);
}

function getMarkerImageUrl(resultNum) {
    // return MAPFILES_URL + "marker" + String.fromCharCode(65 + resultNum) + ".png";
    return mapIconLocation;
}

function addLocationMarker(result) {
    var latLng = new google.maps.LatLng(result.geometry.location.lat(),result.geometry.location.lng());
    locationMarker = new google.maps.Marker({
        'position': latLng,
        'map': map,
        'title': 'TEST',
        'clickable': true,
        'icon': locationIcon,
        'shadow': locationIconShadow
    });

    var openInfoWindow = function openInfoWindow(result, marker) {
        return function() {
            infowindow.setContent(getPlaceComponentsHtml(result.formatted_address));
            infowindow.open(map, marker);
        }
        ;
    };

    google.maps.event.addListener(locationMarker, 'click', openInfoWindow(result, locationMarker));
}

function retrieveData(queryText, queryCallback) {
    // set the query using the parameter
    var encodedQueryText = encodeURIComponent(queryText);
    var query = new google.visualization.Query('https://docs.google.com/spreadsheets/d/1vnqA-Gc7zpkXR2QShiRXB1uBt_gQP5k-bewOcVYWt2w/gviz/tq?gid=0&headers=1&tq=' + encodedQueryText);

    // set the callback function
    query.send(queryCallback);
}

function resetMap() {

    queryLocation = null;

    // close open window
    infowindow.close();

    // clear layer
    if (layer != null) {
        layer.setMap(null);
        layer = null;
    }

    // reset query location
    locationResult = null;

    if (locationMarker != null) {
        locationMarker.setMap(null);
        locationMarker = null;
    }

    // reset markers
    resetMarkers();

    totalPages = 0;
    totalItems = 0;
    offset = 0;

    $("#matchlist").hide();
    $("#directions").hide();
}

function resetMarkers() {
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }
    markers = [];
}

function clearOptions() {
    document.getElementById("query").value = '';
    offset = 0;
}

function selectMarker(n) {
    google.maps.event.trigger(markers[n], 'click');
}

function getAddressComponentsHtml(rowValues, directions) {
    var html = "<div class='address-components'><div><div>";
    html += "<strong>" + rowValues[2] + "</strong>";
    html += "<p>" + rowValues[3] + "<br/>" + rowValues[4] + "&nbsp;" + rowValues[5] + "</p>";
    html += "<div class='controls'></div>";

    calcRoute({lat: rowValues[0], lang: rowValues[1]});
    // if (directions) {
    //     var label = messages['startaddress'];
    //     html += "<input id='route-start' class='textInput' type='textbox' value='" + label + "' onblur='if(trim(this.value) == \"\") {this.value = \"" + label + "\";}' onfocus='if(this.value == \"" + label + "\") {this.value = \"\";}' onkeyup='if (!event) {var event = window.event;} if (event.keyCode != 13) {return;} calcRoute();'/>";
    //     html += "<a class='bigButton' href='#' onclick='calcRoute(); return false;'><div class='redButtonLeft'>" + messages['calculate_route'] + "<div class='redButtonRight'></div></div></a>";
    //     html += "</div></div></div>";
    // }
    return html;
}

function getPlaceComponentsHtml(formattedAddress) {
    var html = "<div class='address-components'><div><div>";
    html += "<strong>" + messages['address'] + "</strong>";
    html += "<p>" + formattedAddress.replace(/, /g, '<br/>') + "</p>";
    html += "</div></div></div>";
    return html;
}

function hasClass(element, className) {
    return element.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
}
function addClass(element, className) {
    if (!hasClass(element, className)) {
        element.className += " " + className;
    }
}

function removeClass(element, className) {
    if (hasClass(element, className)) {
        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
        element.className = element.className.replace(reg, ' ');
    }
}

function trim(value) {
    return value.replace(/^\s+/, '').replace(/\s+$/, '');
}

//begin check NOTICE file
/**
 * Parse the data for geometries or point data
 */
function parseGeoData(data) {
    var columnNames = data[0].map(function(columnName) {
        return columnName.toLowerCase();
    });

    if (columnNames.includes('geometry')) {
        return data;
    }

    var latColumn = getColumnStartingWith(columnNames, 'lat');
    var lngColumn = getColumnStartingWith(columnNames, 'lng') || getColumnStartingWith(columnNames, 'lon');

    if (latColumn && lngColumn) {
        var _ret = function() {
            var latIndex = columnNames.indexOf(latColumn);
            var lngIndex = columnNames.indexOf(lngColumn);

            return {
                v: data.map(function(row, index) {
                    if (index === 0) {
                        row.push('geometry');
                    } else {
                        var point = getGeoJsonPoint(row[lngIndex], row[latIndex]);
                        row.push(point);
                    }
                    return row;
                })
            };
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object")
            return _ret.v;
    }

    var anyGeometryColumn = columnNames.find(function(column) {
        return column.indexOf('geometry') !== -1;
    });

    if (anyGeometryColumn) {
        var anyGeometryIndex = columnNames.indexOf(anyGeometryColumn);

        data[0][anyGeometryIndex] = 'geometry';
        return data;
    }

    var firstRow = data[1];
    var geometryContentIndex = firstRow && firstRow.findIndex(function(cell) {
        try {
            var geoJson = JSON.parse(cell);
            return geoJson && geoJson.type && geoJson.type === 'Feature';
        } catch (error) {
            return false;
        }
    });

    if (geometryContentIndex) {
        data[0][geometryContentIndex] = 'geometry';
        return data;
    }

    return data;
}

/**
 * Get the column name of the column starting with the passed string
 */
function getColumnStartingWith(columnNames, start) {
    return columnNames.find(function(columnName) {
        return columnName.toLowerCase().indexOf(start) === 0;
    });
}

/**
 * Get a point as a GeoJSON point
 */
function getGeoJsonPoint(lng, lat) {
    return '\n    {\n      "type": "Feature",\n      "properties": {},\n      "geometry": {\n        "type": "Point",\n        "coordinates": [' + lng + ', ' + lat + ']\n      }\n    }\n  ';
}

function createGeojsonFromData(data) {
    var featureCollection = {
        type: 'FeatureCollection',
        features: []
    };

    var columns = data[0];

    var geometryColumnName = getGeometryColumnName(data);
    var geometryIndex = columns.indexOf(geometryColumnName);

    if (geometryIndex === -1) {
        return null;
    }

    data.forEach(function(row, index) {
        if (index === 0) {
            return;
        }

        var geoJsonFeature = getGeoJsonWithProperties(row[geometryIndex], columns, row, geometryColumnName);

        if (geoJsonFeature && geoJsonFeature.geometry.coordinates && geoJsonFeature.geometry.coordinates.length) {
            featureCollection.features.push(geoJsonFeature);
        }
    });

    return featureCollection;
}

function getGeometryColumnName(data) {
    var columnNames = data[0].map(function(columnName) {
        return columnName.toLowerCase();
    });

    var anyGeometryColumn = columnNames.find(function(columnName) {
        return columnName.includes('geometry');
    });

    if (anyGeometryColumn) {
        return anyGeometryColumn;
    }

    var firstRow = data[1];
    if (firstRow) {
        var geometryIndex = firstRow.findIndex(function(cell) {
            try {
                var geoJson = JSON.parse(cell);
                return geoJson && geoJson.type && geoJson.type === 'Feature';
            } catch (error) {
                return false;
            }
        });

        return columnNames[geometryIndex];
    }

    return 'geometry';
}

/**
 * Convert the WKT to GeoJSON.
 * As there might be the feature wrapper missing, add it.
 */
function getGeoJsonWithProperties(geoJsonString, columns, row, geometryColumnName) {
    if (!geoJsonString) {
        return null;
    }
    try {
        var geoJson = JSON.parse(geoJsonString);
        geoJson.properties = columns.reduce(function(all, current, currentIndex) {
            if (current === 'geometry') {
                return all;
            }
            all[current] = row[currentIndex] || '';
            return all;
        }, {});
        return geoJson;
    } catch (error) {
        return null;
    }
}

function createIconsFromData(data) {
    var icons = [];
    var columns = data[0];
    var geometryColumnName = getGeometryColumnName(data);
    var geometryIndex = columns.indexOf(geometryColumnName);
    if (geometryIndex === -1) {
        return null;
    }
    data.forEach(function(row, index) {
        if (index === 0) {
            return;
        }
        var icon = getIconWithProperties(row[geometryIndex], columns, row, geometryColumnName);
        if (icon) {
            icons.push(icon);
        }
    });
    return icons;
}

/**
 * Convert a row to an icon
 */
function getIconWithProperties(geoJsonString, columns, row, geometryColumnName) {
    if (!geoJsonString) {
        return null;
    }
    try {
        var geoJson = JSON.parse(geoJsonString);
        if (geoJson.geometry.type !== 'Point') {
            return null;
        }
        return {
            position: geoJson.geometry.coordinates,
            properties: columns.reduce(function(all, current, currentIndex) {
                if (current === 'geometry') {
                    return all;
                }
                all[current] = row[currentIndex] || '';
                return all;
            }, {})
        };
    } catch (error) {
        console.log(error);
        return null;
    }
}

var OFFSET_FROM_MARKER = {
    none: 0,
    small: -7,
    large: -34
};
/**
 * Initialize an infowindow that shows the clicked data
 */
function initInfowindow(map, overlay) {
    map.addListener('mousemove', function(event) {
        if (!overlay._deck || !overlay._deck.layerManager) {
            return;
        }
        var _event$pixel = event.pixel;
        var x = _event$pixel.x;
        var y = _event$pixel.y;

        var picked = overlay._deck.pickObject({
            x: x,
            y: y,
            radius: 0,
            layerIds: [GEOJSON_LAYER_ID, ICON_LAYER_ID]
        });
        document.body.classList.toggle('cursor-pointer', picked);
    });
    map.addListener('click', function(event) {
        var latLng = event.latLng;
        var _event$pixel2 = event.pixel;
        var x = _event$pixel2.x;
        var y = _event$pixel2.y;

        var picked = overlay._deck.pickObject({
            x: x,
            y: y,
            radius: 4,
            layerIds: [GEOJSON_LAYER_ID, ICON_LAYER_ID]
        });
        var markerIconSize = 'none';
        if (picked && picked.layer.id === ICON_LAYER_ID) {
            var _picked$object$positi = _slicedToArray(picked.object.position, 2);

            var lng = _picked$object$positi[0];
            var lat = _picked$object$positi[1];

            latLng = new google.maps.LatLng(lat,lng);
            markerIconSize = 'small';
        }
        if (picked) {
            openInfowindow(infowindow, map, picked.object, latLng, markerIconSize);
        } else {
            infowindow.close();
        }
    });
    var infowindow = new google.maps.InfoWindow({
        content: '',
        maxWidth: 400
    });
}
/**
 * Open the Tooltip for the passed in object
 */
function openInfowindow(infowindow, map, feature, position, markerIconSize) {
    if (!feature || !feature.properties || !map || !position) {
        return;
    }
    var yOffset = OFFSET_FROM_MARKER[markerIconSize];
    infowindow.setOptions({
        pixelOffset: new google.maps.Size(0,yOffset)
    });
    infowindow.setContent(createContent(feature.properties));
    infowindow.setPosition(position);
    infowindow.open(map);
}

function isUrl(value) {
    var lowercaseValue = value.toLowerCase();
    return lowercaseValue.startsWith('www.') || lowercaseValue.startsWith('http://') || lowercaseValue.startsWith('https://') || lowercaseValue.startsWith('//');
}

/**
 * Create the content for the infowindow
 */
function createContent(data) {
    return '<table>\n    ' + Object.keys(data).map(function(key) {
        var value = data[key];
        if (!value)
            return '';
        switch (key) {
        case 'Name':
            value = '<b>' + value + '</b>';
            break;
        case 'Straße':
            break;
        case 'PLZ':
            var city = data['Ort'];
            if (city) {
                value = data[key] + ' ' + city;
            }
            break;
        case 'WEBSEITE':
            var isUrlValue = isUrl(value);
            if (isUrlValue) {
                value = '<a href="' + value + '" target="_blank" rel="noopener"\n              title="Open this link in a new tab">\n            ' + value + '\n          </a>';
            }
            break;
        default:
            value = '';
        }
        return !value ? '' : '<tr>\n          <td>' + value + '</td>\n        </tr>';
    }).join('') + '\n    </table>';
}
//end check NOTICE file


// Draw Routes 
function getCurrentLocation() {
    const currentLocation = new Promise((res, rej) => {
        navigator.geolocation.getCurrentPosition((position) => {
            res(position.coords);
        }, (error) => {
            rej(false);
        });
    });

    currentLocation.then(
        (location) => { currentUserLocation = location },
        (err) => { console.log("err", err) }
    );
}

function calcRoute(destination) {
    if (currentUserLocation) {
        var start = new google.maps.LatLng(currentUserLocation.latitude, currentUserLocation.longitude);
        var end = new google.maps.LatLng(destination.lat, destination.lang);
        var request = {
        origin: start,
        destination: end,
        travelMode: google.maps.TravelMode.DRIVING
        };
        directionsService.route(request, function(response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);
            directionsDisplay.setMap(map);
        } else {
            alert("Directions Request from " + start.toUrlValue(6) + " to " + end.toUrlValue(6) + " failed: " + status);
        }
        });
    }   
}
